import { Modal, Button } from 'rsuite';

export default function DelConfirmDialog(props) {
  const { isOpen, onConfirm, onCancel, data } = props;

  return (
      <Modal open={isOpen} onClose={onCancel}>
        <Modal.Header>
          <Modal.Title>Confirmar</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <p>¿Eliminar el emisor {data.nombre}?</p>
            <p>Al eliminar esta empresa emisora, tambien se eliminarán los certificados asociados a este NIT.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => onConfirm(data.id)} appearance="primary" color={'red'}>
            Eliminar
          </Button>
          <Button onClick={onCancel} appearance="subtle">
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>
  );
};
